import { jsx as e } from "react/jsx-runtime";
import o from "@mui/joy/Typography";
const r = ({ isSearch: r2, hintText: t = "Введіть як мінімум 1 символ", noResultsText: i = "Варіантів не знайдено" }) => e(o, { level: "body-sm", children: r2 ? i : t });
export {
  r as NoOptionsText
};
//# sourceMappingURL=NoOptionsText.js.map
